export function getStaticsBaseUrl(): string {
  const baseUrl = window.__STATICS_BASE_URL__;
  if (!baseUrl) {
    throw new Error('No base Url');
  }
  return baseUrl;
}
